import { observable, runInAction, computed } from 'mobx';
import { get } from '../utils';

class ClassificationList {
  private route: string;
  private params: any;
  @observable
  private classificationListData: any = [];
  constructor(params: any) {

    this.route = params.url;
    this.params = params;
  }

  async fetch(callback?, errs?) {
    var obj = Object.assign(this.params);
    get(this.route, obj).then((d) => {
      let data;
      if (d.data) {
        data = d.data;
        runInAction(() => {
          this.classificationListData = data;
          callback && callback(data);
        });
      } else {
        callback && callback([])
      }
    }).catch((err) => {
      errs && errs(err)
    })
  }

  @computed
  get list() {
    return this.classificationListData.slice();
  }
}
export default ClassificationList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/ClassificationList.ts